import TimeframeCalendarModule from './timeframe-calendar';
import TimeframeDateModule from './timeframe-date';
import DateParserModule from './date-parser';
import {getDateRanges, getDateRangeName} from './date-ranges';
import EventEmitter from '../../services/eventEmitter';
import LocalizationModule from '../../configs/localization/localization';
import Rx from 'rx';
import template from './timeframe.jade';

export class TimeframeController {
  /* @ngInject */
  constructor($filter, $timeout) {
    this.translate = $filter('translate');
    this.timeout = $timeout;
    this.ranges = getDateRanges();
    this.granularities = ['hours', 'days', 'weeks', 'months'];
    this.granularity = this.granularity || 'days';

    this.range = {
      events: new EventEmitter()
    };
    this.range.events.on('changed', ([startDate,endDate]) => {
      this.selectedRangeName = getDateRangeName(startDate, endDate);
    });
    this.selectedRangeName = getDateRangeName(this.startDate, this.endDate);

    this.showComparison = false;
    this.comparison = {
      events: new EventEmitter(),
      select: new Rx.Subject(),
      selecting: 'startDate'
    };
    if (!this.hideComparison && this.comparisonStartDate) {
      this.showComparison = true;
      this.comparison.events.emit('goto', this.comparisonStartDate);
    }
  }

  selectRange(name) {
    this.selectedRangeName = name;
    [this.startDate, this.endDate] = this.ranges[name] || [null, null];

    this.range.events.emit('changed', [this.startDate, this.endDate]);
    this.range.events.emit('goto', this.endDate);
    if (this.startDate) {
      if (this.showComparison) {
        this.selectPreviousPeriod();
      }
    } else {
      this.comparisonStartDate = null;
      this.comparisonEndDate = null;
    }
  }

  selectPreviousPeriod() {
    let rangeLength = moment(this.endDate).diff(this.startDate, 'days');
    this.comparisonStartDate = moment(this.startDate).subtract(rangeLength + 1, 'days').toDate();
    this.comparisonEndDate = moment(this.startDate).subtract(1, 'days').toDate();
    this.comparison.events.emit('goto', this.comparisonStartDate);
  }

  selectGranularity(name) {
    this.granularity = name;
  }

  onComparisonChange() {
    if (this.showComparison) {
      this.comparisonStartDate = null;
      this.comparisonEndDate = null;
    } else {
      this.selectPreviousPeriod();
    }
  }
}

export function TimeframeComponent() {
  return {
    template,
    controller: TimeframeController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      startDate: '=',
      endDate: '=',
      hideComparison: '=',
      comparisonStartDate: '=',
      comparisonEndDate: '=',
      granularity: '=',
      onChange: '&'
    },
    bindToController: true
  };
};

export default angular.module('app.datetime.timeframe', [
  TimeframeCalendarModule.name,
  TimeframeDateModule.name,
  DateParserModule.name,
  LocalizationModule.name
])
.directive('timeframe', TimeframeComponent)



/** WEBPACK FOOTER **
 ** ./src/common/datetime/timeframe.js
 **/